module.exports = __webpack_public_path__ + "static/media/empty-state-hours-flights.7e324330.svg";